<template>
  <div class="sp_userInfo">
    <el-row style="margin-top:8px;"
            type="flex"
            justify="end">
      <el-col :span="24"
              style="text-align:right;">
        <el-dropdown trigger="click"
                     @command="handleCommand"
                     @visible-change="handelVisibleChange">
          <span @mouseenter="showHoverHandler(true)"
                @mouseleave="showHoverHandler(false)"
                @click="showHoverHandler(true)"
                class="el-dropdown-link"
                :class="{'hover-el-dropdown-link':showHover}"
                style="display:flex: justify-content: end; align-item:center;">
            <svg-icon v-show="!showHover"
                      icon-class="newuser"></svg-icon>
            <svg-icon v-show="showHover"
                      icon-class="hoveruser"></svg-icon>
            <span style="overflow: hidden; display: inline-block; text-overflow: ellipsis; max-width: 80%; white-space: nowrap;">{{userInfo.firstName+' '+userInfo.lastName}}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown"
                            class="sp_userDropdown">
            <el-dropdown-item command="personalCenter">
              <svg-icon class="dropdown-svg"
                        icon-class="usercenter" />
              Personal Center
            </el-dropdown-item>
            <el-dropdown-item command="logout">
              <svg-icon class="dropdown-svg"
                        icon-class="logout" /> Log Out
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "usreInfo",
  data () {
    return {
      userInfo: {},
      showHover: false,
      visibleChange: false
    }
  },
  props: {
    tabsData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    showHoverHandler (val) {
      if (val) {
        this.showHover = val
      } else if (!val && !this.visibleChange) {
        this.showHover = val
      }

    },
    handleCommand (data) {
      switch (data) {
        case 'logout':
          this.$store.dispatch("LogOut")
          break;
        case 'personalCenter':
          // const isOpenPersonalCenter = this.tabsData.find(item => {
          //   return item.path === 'personalCenter'
          // })
          // if (isOpenPersonalCenter) {
          //   return
          // }
          this.$emit('personalCenterHandler')
          break;

        default:
          break;
      }
    },
    handelVisibleChange (val) {
      this.visibleChange = val
      this.showHover = val
    }
  },

  watch: {
    '$store.state.user.userInfo' () {
      this.userInfo = this.$store.state.user.userInfo
    }
  },

  created () {
    this.userInfo = this.$store.state.user.userInfo
    // console.log(this.userInfo);
  },

}
</script>

<style scoped lang="scss">
.sp_userInfo {
  width: 100%;
  /deep/.el-dropdown {
    max-width: 100%;
  }
  .el-dropdown-link {
    width: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    .svg-icon {
      font-size: 24px;
      margin-right: 8px;
    }
  }
  .hover-el-dropdown-link {
    color: #007aff;
  }
  .el-dropdown-link:hover {
    color: #007aff;
  }
  .sp_userDropdown {
    .svg-icon {
      font-size: 16px;
      margin-right: 10px;
    }
  }
}
/deep/.el-dropdown-menu__item {
  height: 32px !important;
  line-height: 32px !important;
  padding: 0 16px 0 8px !important;
}
.dropdown-svg {
  margin: 0 8px;
}
</style>